<template>
    <div style="width: 1200px;  margin: 0 auto;">

        <Title :title="{name: '通知中心'}" :button-array="buttonArray" @openNewNotice="openNewNotice"></Title>
        <el-card class="box-card">
            <el-row :gutter="20"  style="margin-left: 10px;">
                <el-col :span="5">
                    <el-input v-model="qparam.letterTitle" placeholder="请输入标题" ></el-input>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="qparam.letterBody" placeholder="请输入内容"
                              style=" margin-left:30px;"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-date-picker
                            style="width:250px;margin-left:30px;"
                            v-model="qparam.createTimeArr"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button icon="el-icon-refresh-left" type="primary" @click="reset">重置</el-button>

                    <el-button icon="el-icon-search"   type="primary" @click="selectListByData">查询</el-button>
                </el-col>
            </el-row>
        </el-card>


        <el-tabs type="border-card" style="min-height: 650px; margin-top: 10px;" @tab-click="changeType">
            <el-tab-pane label="全部通知">
                <el-collapse style="margin-top:10px ; ">
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="total == 0">无数据</div>
                    <div v-for="(item,index) in noticeAll" :key="item.siteLetterId"
                         style=" position: relative;">
                        <el-badge value="未读" class="item" style="width: 98%" :hidden="item.isRead != 2">
                            <el-collapse-item :title="item.letterTitle" :name="index"
                            >
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span class="secondary"> 通知时间: </span>
                                </div>
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span> {{item.createTime}} </span>
                                </div>
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span class="secondary"> 通知内容: </span>
                                </div>
                                <div>{{item.letterBody}}
                                <el-button v-if="item.letterHref" type="text" size="small"
                                           @click="$router.push(item.letterHref)">
                                    <i class="el-icon-s-order
                                    "></i>快捷操作
                                    </el-button>
                                </div>
                                <el-button v-if="item.isRead == 2" type="primary" @click="readNotice(item.siteLetterId)"
                                           plain style="float: right;margin: 10px;" size="small">确认已读
                                </el-button>

                            </el-collapse-item>
                        </el-badge>
                    </div>
                    <div class="block" style="margin-top: 20px;float: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="total"
                                :page-size="size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current">
                        </el-pagination>
                    </div>
                </el-collapse>
            </el-tab-pane>
            <el-tab-pane label="未读通知">
                <el-collapse style="margin-top:10px ; ">
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="total == 0">无数据</div>
                    <div v-for="(item,index) in noticeAll" :key="item.siteLetterId"
                         style=" position: relative;">
                        <el-badge value="未读" class="item" style="width: 98%">
                            <el-collapse-item :title="item.letterTitle" :name="index"
                            >
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span class="secondary"> 通知时间: </span>
                                </div>
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span> {{item.createTime}} </span>
                                </div>
                                <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                                    <span class="secondary"> 通知内容: </span>
                                </div>
                                <div>{{item.letterBody}}
                                    <el-button v-if="item.letterHref" type="text" size="small"
                                               @click="$router.push(item.letterHref)">
                                        <i class="el-icon-s-order
                                    "></i>快捷操作
                                    </el-button>
                                </div>
                                <el-button type="primary" @click="readNotice(item.readId)" plain
                                           style="float: right;margin: 10px;" size="small">确认已读
                                </el-button>
                            </el-collapse-item>
                        </el-badge>
                    </div>
                    <div class="block" style="margin-top: 20px;float: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="total"
                                :page-size="size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current"
                        >
                        </el-pagination>
                    </div>
                </el-collapse>
            </el-tab-pane>
            <el-tab-pane label="已读通知">
                <el-collapse style="margin-top:10px ; ">
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="total == 0">无数据</div>
                    <el-collapse-item v-for="(item,index) in noticeAll" :title="item.letterTitle"
                                      :name="index"
                                      :key="index">
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 通知时间: </span>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span> {{item.createTime}} </span>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 通知内容: </span>
                        </div>
                        <div>{{item.letterBody}}
                            <el-button v-if="item.letterHref" type="text" size="small"
                                       @click="$router.push(item.letterHref)">
                                <i class="el-icon-s-order
                                    "></i>快捷操作
                            </el-button>
                        </div>
                    </el-collapse-item>
                    <div class="block" style="margin-top: 20px;float: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="total"
                                :page-size="size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current">
                        </el-pagination>
                    </div>
                </el-collapse>

            </el-tab-pane>



        </el-tabs>

        <el-dialog
                title="发布新通知"
                :visible.sync="drawer"
               >
            <el-form ref="form" :model="notice" label-position="top" style="margin:0 10px;"  :rules="rules">
                <el-form-item label="通知标题:" style="width:100%;" prop="letterTitle">
                    <el-input v-model="notice.letterTitle" required="true"></el-input>
                </el-form-item>
                <el-form-item label="通知接收人:" prop="userList">
                    <el-transfer
                            filterable
                            filter-placeholder="请输入名字"
                            v-model="notice.userList"
                            :data="data"
                            :titles="['全部员工','已选员工']"
                    >
                    </el-transfer>
                </el-form-item>


                <el-form-item label="通知内容:" prop="letterBody">
                    <el-input type="textarea" v-model="notice.letterBody" rows="4" style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="newNotice()">立即发布</el-button>
                    <el-button @click="drawer=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import Title from "../../Title"
    import {requestSiteletterRead, requestSiteletterSelectListByData,requestUserGet,requestSiteletterAdd} from "../../../api";

    export default {
        components: {Title},
        data() {
            return {
                qparam: {
                    type: 0, // 1 已读 2未读 3全部
                    letterTitle: '',
                    letterBody: '',
                    createTimeArr: [],
                    current: 1,
                },
                total: 0,
                size: 8,
                noticeAll: [],
                buttonArray:[{
                    type: 'success',
                    title: '发布新通知',
                    method: 'openNewNotice',
                    disabled:false,
                }],
                drawer: false,
                notice: {
                    letterTitle: '',
                    letterBody: '',
                    userList: [],
                },
                data:[],
                rules: {
                    letterTitle: [
                        {required: true, message: '请选择通知标题', trigger: 'change'},
                        { max: 40, message: '长度不能超过40个字符', trigger: ['change', 'blur']}
                    ],
                    letterBody: [
                        { required: true, message: '请输入通知内容', trigger: 'change'}
                    ],
                    userList: [
                        { required: true, message: '请选择接收人', trigger: 'blur'}
                    ]
                },
            }
        }, methods: {
            newNotice(){
                this.$refs.form.validate(ispass =>{
                    if(ispass){
                        let noticeData = this.notice;
                        noticeData.userList = this.notice.userList.join(",")
                        requestSiteletterAdd(noticeData).then((result) => {
                            if(result.code == 200){
                                this.$refs.form.resetFields();
                                this.$message.success(result.msg);
                                this.drawer=false;
                                this.selectListByData();
                            }else{
                                this.$message.error(result.msg);
                            }
                        }).catch((err)=>{
                            this.$message.error("网络错误");
                        })
                    }
                })

            },
            openNewNotice(){
                this.drawer = true;
            },
            // 显示第几页
            handleCurrentChange(val) {
                this.qparam.current = val
                this.selectListByData();
            },
            async readNotice(readId) {
                let param = {'readId': readId}
                const res = await requestSiteletterRead(param);
                if(res.code == 200){
                    this.$message.success(res.msg);
                    this.selectListByData();
                }else{
                    this.$message.error(res.msg);
                }
            },
            async selectListByData() {
                this.qparam.startTime = this.qparam.createTimeArr[0];
                this.qparam.endTime = this.qparam.createTimeArr[1];
                const res = await requestSiteletterSelectListByData(this.qparam);
                if(res.code == 200){
                    this.noticeAll=res.rows;
                    this.total = res.total;
                }else{
                    this.$message.error(res.msg);
                }
            },
            changeType(type) {
                this.qparam.type = type.index;
                this.selectListByData();
            }, reset() {
                this.qparam = {
                    type: this.qparam.type, // 2 已读 1未读 3全部
                    letterTitle: '',
                    letterBody: '',
                    createTimeArr: [],
                    current: 1,
                };
                this.selectListByData();
            },
            async getAllCount() {
                const res = await requestUserGet();
                if(res.code == 200){
                    const userList = res.object;
                    userList.forEach((user) => {
                        this.data.push({
                            label: user.realName,
                            key: user.userId
                        })
                    })
                }else{
                    this.$message.error(res.msg);
                }
            }
        }, created() {
            this.selectListByData();
            this.getAllCount();
        },
    }
</script>

<style>


    .el-dialog__body {
/*        overflow: auto;*/
        /* overflow-x: auto; */
    }

    .rightBut {
        position: absolute;
        color: #fff;
        background: #ff4141;
        border-radius: 15px;
        padding: 2px 7px;
        font-size: 12px;
        right: 37px;
        top: 13px;
    }

   .el-dialog{
       margin-bottom: 1px !important;
   }


</style>
